import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import arrowLeftSvg from 'assets/icons/arrow_left.svg';
import { Store } from 'components/common/types/Store.types';
import { Creative, CreativeCountSummary } from 'components/common/types/Creative.types';
import { CreativeType } from 'components/common/types';
import IconButton from 'lib/IconButton';
import { Theme } from 'lib/IconButton/IconButton.types';
import CreativeCount from '../../CreativeCount';
import DspPopup from './DspPopup';

const EditCreativesHeader: React.FC = () => {
  const navigate = useNavigate();

  const selectedCreatives = useSelector((state: Store) => state.pages.contentManagement.creatives.selectedCreatives);

  const handleBackToClick = (): void => {
    navigate('/content-management');
  };

  const creativeCountSummary = useMemo<CreativeCountSummary>(
    () => ({
      staticCreatives: selectedCreatives.filter(
        (creative: Creative) => creative.type === CreativeType.BANNER || creative.type === CreativeType.DYNAMIC,
      ).length,
      motionCreatives: selectedCreatives.filter((creative: Creative) => creative.type === CreativeType.VIDEO).length,
    }),
    [selectedCreatives],
  );

  return (
    <div className="flex items-center justify-between px-6 pt-5">
      <div className="flex items-center">
        <IconButton
          icon={arrowLeftSvg}
          name="back-to-creatives"
          dataTestId="back-to-creatives"
          handleOnClick={handleBackToClick}
          theme={Theme.PRIMARY}
        />
        <h2 className="ml-6 header-xl text-neutral-950">Edit creatives</h2>
      </div>
      <div className="flex space-x-2 justify-between items-center">
        <CreativeCount
          totalCreatives={selectedCreatives?.length > 0 ? selectedCreatives.length : 0}
          creativeCountSummary={creativeCountSummary}
          theme="DARK"
        />
        <span className="ml-2 text-neutral-100">&bull;</span>
        <DspPopup />
      </div>
    </div>
  );
};

export default EditCreativesHeader;
